import * as React from "react";
import { CheckPricesProps } from "./typings";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";
import { Container } from "./component/Container";
import { Deal } from "./component/Deal";

const checkPricesKey = new ItemKeyHelper("check-prices");
const checkPricesV3Keys = ["today", "tomorrowNight", "thisWeekend", "nextWeekend", "bestWeekend"];

export const viewContext = React.createContext<string>("");
const ViewProvider = viewContext.Provider;

export const CheckPrices = (props: CheckPricesProps) => {
  const { context, flexComponent, l10n } = props;
  const searchContext = context && context.searchContext;
  const model = flexComponent.model;

  const containerProps = {
    title: model.title,
    id: flexComponent.id,
    fmId: flexComponent.fmId,
    fmTitleId: flexComponent.fmTitleId,
    view: model.view
  };

  return (
    <ViewProvider value={model.view}>
      <Container {...containerProps}>
        {checkPricesV3Keys.map(modelKey => (
          <Deal
            key={checkPricesKey.next()}
            modelKey={modelKey}
            model={model}
            searchContext={searchContext}
            l10n={l10n}
          />
        ))}
      </Container>
    </ViewProvider>
  );
};

export default CheckPrices;
